import { Directive, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[hideMobileFooter]',
  standalone: true,
})
export class HideMobileFooterDirective implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {
    this.isHideFooter(true);
  }

  isHideFooter(value: boolean) {
    let footer = document.querySelector('fgb-footer');
    if (value) {
      footer?.classList.add('d-none');
    } else {
      footer?.classList.remove('d-none');
    }
  }

  ngOnDestroy(): void {
    this.isHideFooter(false);
  }
}
